import React, { createContext, useState, useContext, useEffect } from 'react';

import { MyContext } from '../ProviderContext';

export const EngineeringDesign = () => {
    const { menuComponent, setMenuComponent } = useContext(MyContext);

    useEffect(() => {
        setMenuComponent({ home: '', about: '', services: 'active', team: '', contact: '', project: '' });
    }, [])

    return (

        <>
            <div className="page-header">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2>Engineering Design</h2>
                        </div>
                        <div className="col-12">
                            <a href="">Home</a>
                            <a href="">EngineeringDesing</a>
                        </div>
                    </div>

                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-8">
                        <img src='/img/engineering.png' width="100%" />
                        <p className=' about-text'>
                        You get  <span style={{ color: 'red' }}>accurate designs</span> that are  <span style={{ color: 'red' }}>compliant with international codes and standards</span> and certified by our engineers who are recognized engineers with
                        COREN, NSE, SPE, ASME, ASTM, etc. Our engineers are tech savvy with hands-on knowledge of designing with the latest computer aided engineering design software
                        </p>
                    </div>
                    <div className='col-4 about-text'>
                        <h3>Engineering Service <span style={{ color: 'red' }}> redefined</span> and <span style={{ color: 'red' }}>modernized. </span></h3>
                        <p>

                            You can rely on FRANTINO to adequately define your project requirements before initiating capital investments. Our experienced Front End Engineering Design
                            (FEED) team, can excellently:
                            <br /> <br />
                            <i className="fui-check"></i> Define your technical and project-specific requirements for an understanding of clear project scope. <br />
                            <i className="fui-check"></i> Prepare the project approach and basis of design for the system. <br />
                            <i className="fui-check"></i> Develop good project cost estimate for budget authorization. <br />
                            <i className="fui-check"></i> Drastically reduce the risk of the project. <br />
                            <i className="fui-check"></i> Estimate the project duration and schedule during the detailed design phase

                        </p>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        <img src='img/3dmodel.png' width='100%'  />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-8'><img src='img/software-1.png' width='100%' /> </div>
                    <div className='col-4'><img src='img/software-2.png' width='100%' /> </div>
                </div>
            </div>
        </>
    )
}